/**
 * @flow
 * @format
 */

import { branch, renderComponent, type HOC } from 'recompose';

import Loading from '~/components/Loading';

type B = {
  loading: boolean,
  hasError: boolean,
  currentStep: string,
};

const withLoader: HOC<*, B> = branch(
  (props: B) => props.loading,
  renderComponent(Loading),
);

export default withLoader;



// WEBPACK FOOTER //
// ./src/hoc/withLoader.js